import { UserIdProvider, UserIdContext } from './userid-provider'

const UserId = {
  provider: UserIdProvider,
  context: UserIdContext,
}

export default UserId
